export default {
  // formServiceApi: ENV.formServiceApi,
  // apiSuzuki: ENV.apiSuzuki,
  // formServiceDatasource: ENV.formServiceDatasource,
  // reCaptchaPublicKey: ENV.reCaptchaPublicKey,
  // country: 'by'

  // dealerId: "cein88qnifss7393daog",
  // cityId: "cein3i2nifss7393dai0",
  termsLink: "/suzuki/yuridicheskaya-informaciya/",

  perxis: {
    ids: {
      space: "cid9272nifss73be1mt0",
      env: "cid9272nifss73be1mtg",
      cities: "dealers_cities",
      dealers: "dealers_dealerships",
    },
  },

  service: {
    hosts: {
      forms: "https://forms.platform.perxis.ru/form/",
      data: "https://suzuki-motor.ru/data/",
    },
    endpoints: {
      dealers: "/dealer-centers-by-city/index.json",
    },
  },

  widget: {
    config: {
      id: "forms_requests_accessory",
    },
    form_data_params: {
      // price: 123,
      // sku: 123,
    },
    event: {
      send: () => {},
      prepare_data: (data: any) => data,
    },
  },
};
